import { useMemo } from 'react';
import { useMsal } from '@azure/msal-react';

/** Microsoft Entra ID token `roles` claim (app roles), normalized to a string array. */
export function useEntraAppRoles(): string[] {
  const { accounts } = useMsal();
  return useMemo(() => {
    const raw = accounts[0]?.idTokenClaims?.roles as string[] | string | undefined;
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'string' && raw) return [raw];
    return [];
  }, [accounts]);
}

export function useHasEntraRole(role: string): boolean {
  return useEntraAppRoles().includes(role);
}
